import React, {useEffect, useRef, useState} from 'react';
import {Box, Spinner, useDimensions} from '@chakra-ui/react';
import TeamBioHero from './TeamBio/Components/Hero';
import SlideShow from './TeamBio/Components/SlideShow';
import Podcasts from './TeamBio/Components/Podcasts';
import PortfolioList from './TeamBio/Components/List';
import axios from "axios";
import {useParams} from "react-router-dom";
import {SEO} from "../components/SEO";
import FullCrossPlus from "../components/FullCrossPlus";

const TeamBioPage = () => {
    const [bioData, setBioData] = useState(undefined)
    const {slug} = useParams();
    const pageRef = useRef();

    const dimen = useDimensions(pageRef, true);

    const count = Math.floor(dimen?.contentBox.height / 393) + 1 || 0;

    useEffect(() => {
        const fetchBio = async () => {
            const response = await axios.get(`/wp-json/wp/v2/teammember?acf_format=standard&slug=${slug}`).then(resp => {
                return resp.data[0];
            });
            setBioData(response)
        }
        fetchBio()
    }, [slug])

    return (
        <Box ref={pageRef}>
            {Array(count)
                .fill('')
                .map((_, key) => (
                    <FullCrossPlus index={key + 1} top={393 * (key + 1)} key={key}/>
                ))}
            <SEO
                image={bioData?.yoast_head_json?.og_image[0]?.url}
                title={bioData?.title?.rendered}
                ogTitle={bioData?.yoast_head_json?.og_title}
                description={bioData?.yoast_head_json?.og_description}
                url={bioData?.yoast_head_json?.og_url}
                type={bioData?.yoast_head_json?.og_type}
                siteName={bioData?.yoast_head_json?.og_site_name}
                robots={`${bioData?.yoast_head_json?.robots.index}, ${bioData?.yoast_head_json?.robots.follow}`}
            />
            {!bioData ?
                (
                    <Box my={20}>
                        <Spinner color='blue.600' size='xl'/>
                    </Box>
                )
                :
                (<Box px={['5', '10']}>
                        <TeamBioHero data={bioData}/>
                        <PortfolioList/>
                        {bioData.acf?.carousel_items?.length > 0 &&
                            <SlideShow data={bioData}/>
                        }
                        <Podcasts data={bioData}/>
                    </Box>
                )}
        </Box>
    );
};

export default TeamBioPage;
